module.exports = __webpack_public_path__ + "static/media/microservices.b21a238e.svg";